// eslint-disable-next-line import/no-unresolved
import Swiper from 'swiper/bundle';

// import styles bundle
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/bundle';

/* eslint-disable */

jQuery( $ => {
	new Swiper( '.page-template-contact-page-updated .swiper', {
		slidesPerView: 'auto',
		keyboardControl: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

	} );

	let flag = true;
	let base64file = '';

	$( '.page-template-contact-page-updated .swiper-slide' ).on( 'click', function( e ) {
		e.preventDefault();

		$( '.department__container, .stage-crumb.two + .stage-heading, .stage-crumb.two' ).addClass( 'initiated' );

		const $businessSelection = $( this ).data( 'business-selection' );
		const $target = $( '.contact-department__item' ).find( '[data-business-value="' + $businessSelection + '"]' );

		// hide all sections not relevant for current business selection
		$( '.contact-department__item' ).find( '[data-business-value]' ).hide();

		//except the one connected to the one we clicked
		$target.show();

		// If all subsections are hidden, than also hide parent container
		$( '.department__subsection' ).each( function() {
			let allHidden = true;
			const $outerThis = $( this );

			$outerThis.children().each( function() {
				// If anyone is visible, dont hide
				if ( $( this ).css( 'display' ) !== 'none' ) {
					allHidden = false;
				}
			} );

			$outerThis.closest( '.department__container' ).show();
			if ( allHidden ) {
				$outerThis.closest( '.department__container' ).hide();
			}
		} );

		const $targetElement = $( '.department__container:visible:first' );

		if ( flag ) {
			$( 'body, html' ).animate( {
				scrollTop: $targetElement.offset().top - 170,
			}, 1000 );
			flag = false;
		}

		// Make subsections clickable
		$( '.department__container' ).css( 'pointer-events', 'auto' );
	} );

	// Open or close the the different sections when clicking plus sign (toggle), header or subtext
	$( '.department__toggle, .department__heading, .department__subtext' ).on( 'click', function( e ) {
		e.stopPropagation();

		const clicked = $( this );

		let $subSection;

		if ( clicked.hasClass( 'department__toggle' ) || clicked.hasClass( 'department__heading' ) || clicked.hasClass( 'department__subtext' ) ) {
			$subSection = clicked.parent().children( '.department__subsection' );
		} else {
			return;
		}

		if ( $subSection.is( ':visible' ) ) {
			clicked.children( 'svg:first-of-type' ).hide();
			clicked.children( 'svg:last-of-type' ).show();
			$subSection.fadeOut();
			$subSection.siblings( '.department__heading' ).removeClass( 'active' );
			$subSection.siblings( '.department__heading' ).attr( 'aria-expanded', 'false' );
			$subSection.attr( 'hidden', '' );
		} else {
			clicked.children( 'svg:first-of-type' ).show();
			clicked.children( 'svg:last-of-type' ).hide();
			$subSection.fadeIn();
			$subSection.siblings( '.department__heading' ).addClass( 'active' );
			$subSection.siblings( '.department__heading' ).attr( 'aria-expanded', 'true' );
			$subSection.removeAttr( 'hidden' );
		}
	} );

	// Add a color on clicked slide
	$( '.page-template-contact-page-updated .swiper-slide' ).on( 'click', function( ) {
		$( '.page-template-contact-page-updated .swiper-slide' ).removeClass( 'selected' );
		$( this ).addClass( 'selected ' );
	} );

	/**
	 * When submitting the form.
	 * We want to run logic to send the form to the server.
	 */
	$( '.page-template-contact-page-updated .step-three-form' ).submit( function( event ) {
		event.preventDefault();

		const $form = $( this );
		$form.find( '.contact-spinner' ).css( 'display', 'inline-block' );
		$form.find( "[type='submit']" ).prop( 'disabled', true );
		// setButtonsDisabled( 'disabled' );

		//temporary fix to redirect Germany forms to Denmark in salesforce.
		const checkCountryGermanyFix = country => country === 'Germany' ? 'Denmark' : country;

		function checkFileNameFix( file ) {
			if ( ! file || file.length <= 0 ) {
				return '';
			}
			return file[ 0 ].name;
		}

		// Remove "data:image/jpeg;base64" from file name since Salesforce doesn't want it.
		const fileString = base64file.split( 'base64,' )[ 1 ];

		const fileInputField = $( this ).find( 'input[name="filePicker"]' );
		// Some forms doesnt have file input fields, depends on which business unit etc.
		let inputFileName = '';
		if ( fileInputField && fileInputField.length > 0 ) {
			inputFileName = checkFileNameFix( $( this ).find( 'input[name="filePicker"]' )[ 0 ].files );
		}

		const sendForm = {
			action: 'contactPage',
			nonce: $( this ).find( 'input[name="_wpnonce"]' ).val(),
			name: $( this ).find( 'input[name="firstName"]' ).val() + ' ' + $( this ).find( 'input[name="lastName"]' ).val(),
			email: $( this ).find( 'input[name="email"]' ).val(),
			phone: $( this ).find( 'input[name="phoneNumber"]' ).val(),
			reason: $( this ).find( 'input[name="reason"]' ).val(),
			category: $( this ).find( 'input[name="category"]' ).val(),
			message: $( this ).find( 'textarea[name="message"]' ).val(),
			subject: $( this ).find( '#subject-input' ).val(),
			market: checkCountryGermanyFix( $( this ).find( 'select[name="country"]' ).find( ':selected' ).val() ),
			deviceId: $( this ).find( 'input[name="deviceId"]' ).val(),
			orderNumber: $( this ).find( 'input[name="orderNumber"]' ).val(),
			invoiceNumber: $( this ).find( 'input[name="invoiceNumber"]' ).val(),
			file: fileString,
			fileName: inputFileName,
		};

		const $restUrl = $( this ).data( 'resturl' );

		fetch( $restUrl + 'addsecure/v1/contact', { //eslint-disable-line
			method: 'POST',
			headers: {
				'Content-Type': 'application/json; charset=utf-8',
				'Access-Control-Allow-Origin': '*',
			},
			credentials: 'same-origin',
			body: JSON.stringify( sendForm ),
		} ).then( function( response ) {
			return response.json();
		} ).then( function( responseData ) { //eslint-disable-line
			if ( responseData === 'false' || responseData?.data?.status >= 400 ) {
				// Reset first.
				$form.find( '.form-sent' ).attr( 'hidden', '' );
				$form.find( '.contact-label__error' ).attr( 'hidden', '' );

				// Show generic error message.
				$form.find( '.form-error' ).removeAttr( 'hidden' );

				if ( responseData?.data?.status === 400 ) {

					const additionalErrors = responseData?.additional_errors || [];
					delete responseData.additional_errors;
					const allErrors = [
						responseData,
						...additionalErrors
					];

					allErrors.forEach( function( singleError ) {
						// If we have our own error, lets also find the corresponding error message from the response data.
						const errorCode = singleError?.code || '';
						const errorMessage = singleError?.message;
						const errorEl = $form.find( '.contact-label__error[data-error-code="' + errorCode + '"]' );
						if ( errorEl ) {
							// If we have an error message and there is not already one set for this field, set this.
							if ( errorMessage && errorEl.text() === ''  ) {
								errorEl.text( errorMessage );
							}
							errorEl.removeAttr( 'hidden' );
						}
					} );
				}
			} else {
				$form.find( '.contact-label__error' ).attr( 'hidden', '' );
				$form.find( '.form-error' ).attr( 'hidden', '' );
				$form.find( '.form-sent' ).removeAttr( 'hidden' );
			}
		} ).finally( function( data ) {
			$form.find( '.contact-spinner' ).css( 'display', 'none' );
			$form.find( "[type='submit']" ).prop( 'disabled', false );
		} );
	} );

	// Handles file upload of input file since on some forms you can upload files to Salesforce
	$( '.page-template-contact-page-updated .step-three-form #filePicker' ).change( function() {
		const input = this;
		const files = input.files;
		const file = files[ 0 ];

		getBase64( file );
	} );

	$( '.page-template-contact-page-updated .PhoneInputCountrySelect' ).on( 'change', function() {
		$( '.page-template-contact-page-updated .PhoneInputCountryIconImg' ).attr( 'src', 'https://purecatamphetamine.github.io/country-flag-icons/3x2/' + this.value + '.svg' );

		$( '.PhoneInputCountryIconImg' ).prop( 'alt', $( this ).children( 'option' ).filter( ':selected' ).text() );
	} );

	function getBase64( file ) {
		const reader = new window.FileReader();
		reader.readAsDataURL( file );
		reader.onload = function( e ) {
			base64file = e.target.result;
		};
		reader.onerror = function( error ) {
			console.log( 'Error: ', error ); //eslint-disable-line
		};
	}

	if ( $( '.page-template-contact-page-updated' )[ 0 ] ) {
		let language = document.querySelector( 'html' )
			.getAttribute( 'lang' )
			.toUpperCase();
		if ( language.includes( '-' ) ) {
			language = language.split( '-' )[ 1 ];
		}
		if ( language ) {
			$( '.page-template-contact-page-updated .PhoneInputCountrySelect' ).each( function( ) {
				$( this ).val( language ).change();
			} );

			$( '.page-template-contact-page-updated .PhoneInputCountryIconImg' ).each( function( ) {
				$( this ).attr( 'src', 'https://purecatamphetamine.github.io/country-flag-icons/3x2/' + language + '.svg' );
			} );
			const $altTag = $( ".PhoneInputCountrySelect option[value='" + language + "']" )[ 0 ].text;
			$( '.page-template-contact-page-updated .PhoneInputCountryIconImg' ).prop( 'alt', $altTag );
		}
	}
} );
